export default __webpack_public_path__ + "static/B0300-195779021c71b2cf3a96d14b8e64b70e.png";